<section>

    <app-gjt></app-gjt>

    <div class="container list-user">
        <div class="mat-elevation-8">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Apellido</th>
                <th>Usuario</th>
                <th>Editar</th>
                <th>Eliminar</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let element of user | paginate: { itemsPerPage: 3, currentPage: p }">
                <td>{{element.firstname}}</td>
                <td>{{element.firstlastname}}</td>
                <td>{{element.email}}</td>
                <td class="example-buttom-container">
                  <button mat-fab color="primary" aria-label="Editar Usuario" matTooltip="Editar">
                  <mat-icon class="cd">
                      <a [routerLink]="['/user-edit', element._id]">create</a>
                  </mat-icon>
                  </button>
                </td>
                <td>
                  <button mat-fab color="primary" aria-label="Eliminar Usuario" matTooltip="Eliminar">
                    <mat-icon class="cd">
                      <a (click)='onDeleteConfirm(element._id)'>delete</a>
                    </mat-icon>
                    </button>
                </td>
                <td>
                  <div class="secure" *ngIf="confirm == element._id">
                    <a (click)="onDeleteEvent(element._id)" class="btn btn-sm btn-danger">
                      Eliminar
                    </a>
                    <a (click)="onCancelEvent()" class="btn btn-sm btn-secondary">
                      Cancelar
                    </a>
                </div>
  
                </td>
              </tr>
            </tbody>
          </table>
          <pagination-controls (pageChange)="p = $event"></pagination-controls>
        </div>
    </div>
</section>